<template>
  <section
    class="contactSection"
    :style="{ backgroundImage: `url(${blue})` }"
  >

    <div class="contactOverlay"></div>

    <b-container class="contactContainer">

      <div class="contactIntro">

        <div class="introLine"></div>

        <span class="eyebrow">
          OCS SPORT
          <span class="eyebrowDot"></span>
          GET IN TOUCH
        </span>

        <h2>
          Let's talk about
          <span>your golf tour</span>
        </h2>

        <p>
          Whether you're looking for tour management software, live scoring,
          tournament operations, websites or mobile applications, our team
          would be happy to discuss how OCS Sport can support your organisation.
        </p>

      </div>


      <div class="request-a-callback-form">

        <!-- Success -->
        <transition name="fade" mode="out-in">

          <div
            v-if="sent"
            class="thanksBox"
          >

            <div class="successIcon">
              ✓
            </div>

            <h3>
              Thank you
            </h3>

            <p>
              Thanks for contacting us. We will get back to you shortly.
            </p>

          </div>

        </transition>


        <!-- Form -->
        <template v-if="!sent">

          <form
            @submit.prevent="submitForm"
          >

            <input
              type="hidden"
              name="access_key"
              :value="web3AccessKey"
            >

            <b-row>

              <!-- Left -->
              <b-col
                lg="6"
                class="formColumn"
              >

                <div class="field">
                  <label for="name">Name</label>

                  <input
                    id="name"
                    v-model="name"
                    type="text"
                    name="name"
                    required
                    placeholder="Your name"
                  >
                </div>


                <div class="field">
                  <label for="phone">Phone</label>

                  <input
                    id="phone"
                    v-model="phone"
                    type="text"
                    name="phone"
                    required
                    placeholder="Your phone number"
                  >
                </div>


                <div class="field">
                  <label for="email">Email</label>

                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    name="email"
                    required
                    placeholder="Your email address"
                  >
                </div>


                <div class="field">
                  <label for="subject">Subject</label>

                  <input
                    id="subject"
                    v-model="subject"
                    type="text"
                    name="subject"
                    required
                    placeholder="How can we help?"
                  >
                </div>

              </b-col>


              <!-- Right -->
              <b-col
                lg="6"
                class="formColumn"
              >

                <div class="field messageField">

                  <label for="message">Message</label>

                  <textarea
                    id="message"
                    v-model="message"
                    name="message"
                    required
                    placeholder="Tell us a little about your requirements..."
                  ></textarea>

                </div>
                <div
                  ref="turnstile"
                  class="turnstileContainer"
                ></div>

              </b-col>

            </b-row>


            <div class="formFooter">

              <p class="privacyText">
                We'll only use your details to respond to your enquiry.
              </p>

              <button
                type="submit"
                class="submitButton"
                :disabled="sending"
              >
                <span v-if="!sending">
                  Send enquiry
                  <span class="buttonArrow">→</span>
                </span>

                <span v-else>
                  Sending...
                </span>
              </button>

            </div>

          </form>

        </template>

      </div>

    </b-container>

  </section>
</template>
<script>
const WEB3FORMS_ACCESS_KEY = "1250e827-33bc-40b2-a767-c3f956298022";

export default {
  name: "Form",

  data() {
    return {
      website: "OCS Sport Enquiry",
      name: "",
      email: "",
      phone: "",
      message: "",
      subject: "",

      options: [
        { value: null, text: "Please Select from the dropdown list" },
        { value: "Book a tour", text: "Book a tour" },
        { value: "Private and discreet booking", text: "Private and discreet booking" },
        { value: "Corporate membership", text: "Corporate membership" },
        { value: "Pay and play", text: "Pay and play" },
        { value: "Group membership", text: "Group membership" },
        { value: "General enquiry", text: "General enquiry" },
      ],

      selected: null,
      result: "",
      text: "",
      sent: false,
      sending: false,
      turnstileToken: null,
      turnstileWidgetId: null,
    };
  },

  props: ["blue"],

  methods: {
      loadTurnstile() {
        const checkTurnstile = setInterval(() => {
          if (window.turnstile) {
            clearInterval(checkTurnstile);
            this.turnstileWidgetId = window.turnstile.render(
              this.$refs.turnstile,
              {
                sitekey: "0x4AAAAAAEtrRr92OBffj1xG",

                callback: (token) => {
                  console.log("Turnstile token received"); 
                  this.turnstileToken = token;
                },

                "expired-callback": () => {
                  console.log("Turnstile token expired");
                  this.turnstileToken = null;
                },

                "error-callback": (error) => {
                  console.error("Turnstile error:", error);
                  this.turnstileToken = null;
                  return true;
                }
              }
            );
          }
        }, 100);
      },

      async submitForm() {
        this.sending = true;
        // Make sure Turnstile has been completed
        if (!this.turnstileToken) {
          this.result = false;
          this.text = "Please complete the security check.";
          return;
        }

        try {
          const response = await fetch(
              "/api/contact",
            {
              method: "POST",

              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },

              body: JSON.stringify({
                access_key: WEB3FORMS_ACCESS_KEY,

                website: this.website,
                name: this.name,
                email: this.email,
                phone: this.phone,
                subject: this.subject,
                message: this.message,
                turnstileToken: this.turnstileToken,
              }),
            }
          );

          const result = await response.json();

          console.log("Web3Forms response:", result);

          if (result.success) {
            this.sent = true;
            this.sending = false;

            // Reset Turnstile
            if (window.turnstile && this.turnstileWidgetId !== null) {
              window.turnstile.reset(this.turnstileWidgetId);
            }

            this.turnstileToken = null;
          } else {
            this.sending = false;

            this.result = false;
            this.text =
            result.message || "There was a problem submitting the form.";
          }

        } catch (error) {
          console.error("Form submission error:", error);

          this.result = false;
          this.text =
            "There was a problem submitting the form. Please try again.";
        }
      },
  },

  mounted() {
    this.loadTurnstile();
  },
};
</script>
<style scoped>

.turnstileContainer {
  display: block;
  margin-left: -50px;
  margin-top: 30px;
  width: 330px;
}
.contactSection {
  position: relative;

  background-size: cover;
  background-position: center;

  padding: 100px 0 110px;

  overflow: hidden;
}

.contactOverlay {
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      135deg,
      rgba(10, 25, 35, 0.94),
      rgba(10, 25, 35, 0.82)
    );
}

.contactContainer {
  position: relative;

  z-index: 2;
}


/* =========================================
   INTRO
========================================= */

.contactIntro {
  max-width: 800px;

  margin: 0 auto 55px;

  text-align: center;
}

.introLine {
  width: 55px;
  height: 4px;

  margin: 0 auto 25px;

  background: #00aeef;
}

.eyebrow {
  display: flex;

  justify-content: center;
  align-items: center;

  gap: 10px;

  margin-bottom: 20px;

  color: #00aeef;

  font-size: 11px;
  font-weight: 700;

  letter-spacing: 1.8px;
}

.eyebrowDot {
  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: rgba(255, 255, 255, 0.45);
}

.contactIntro h2 {
  margin: 0 0 20px;

  color: #ffffff;

  font-size: 48px;
  line-height: 1.15;

  font-weight: 700;

  letter-spacing: -0.8px;
}

.contactIntro h2 span {
  color: #00aeef;
}

.contactIntro p {
  max-width: 700px;

  margin: 0 auto;

  color: rgba(255, 255, 255, 0.78);

  font-size: 17px;
  line-height: 1.7;
}


/* =========================================
   FORM CARD
========================================= */

.request-a-callback-form {
  max-width: 1050px;

  margin: 0 auto;

  padding: 45px;

  background: rgba(255, 255, 255, 0.97);

  box-shadow:
    0 25px 70px rgba(0, 0, 0, 0.22);
}


/* =========================================
   FORM COLUMNS
========================================= */

.formColumn {
  padding: 0 15px;
}


/* =========================================
   FIELDS
========================================= */

.field {
  margin-bottom: 25px;
}

.field label {
  display: block;

  margin-bottom: 8px;

  color: #111820;

  font-size: 11px;
  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 1.2px;
}

.field input,
.field textarea {
  display: block;

  width: 100%;

  box-sizing: border-box;

  border: 1px solid #dfe3e6;

  border-radius: 0;

  background: #ffffff;

  color: #111820;

  font-family: inherit;

  font-size: 16px;

  transition:
    border-color 0.25s ease,
    box-shadow 0.25s ease,
    background 0.25s ease;
}

.field input {
  height: 55px;

  padding: 0 17px;
}

.field textarea {
  min-height: 295px;

  padding: 17px;

  resize: vertical;
}

.field input::placeholder,
.field textarea::placeholder {
  color: #9aa2a8;
}

.field input:focus,
.field textarea:focus {
  outline: none;

  border-color: #00aeef;

  background: #ffffff;

  box-shadow:
    0 0 0 3px rgba(0, 174, 239, 0.10);
}


/* =========================================
   MESSAGE
========================================= */

.messageField {
  height: 100%;
}

.messageField textarea {
  height: calc(100% - 27px);
}


/* =========================================
   FORM FOOTER
========================================= */

.formFooter {
  display: flex;

  justify-content: space-between;
  align-items: center;

  gap: 30px;

  margin-top: 5px;

  padding-top: 25px;

  border-top: 1px solid #e5e8ea;
}

.privacyText {
  margin: 0;

  color: #8a9298;

  font-size: 12px;

  line-height: 1.5;
}


/* =========================================
   BUTTON
========================================= */

.submitButton {
  display: inline-flex;

  align-items: center;

  justify-content: center;

  gap: 10px;

  min-width: 190px;

  padding: 15px 25px;

  border: 0;

  border-radius: 0;

  background: #00aeef;

  color: #ffffff;

  font-size: 13px;

  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 1px;

  cursor: pointer;

  transition:
    background 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.submitButton:hover:not(:disabled) {
  background: #009bd6;

  transform: translateY(-2px);

  box-shadow:
    0 8px 20px rgba(0, 174, 239, 0.25);
}

.submitButton:disabled {
  opacity: 0.65;

  cursor: not-allowed;
}

.buttonArrow {
  font-size: 19px;

  transition: transform 0.25s ease;
}

.submitButton:hover .buttonArrow {
  transform: translateX(4px);
}


/* =========================================
   SUCCESS
========================================= */

.thanksBox {
  min-height: 360px;

  display: flex;

  flex-direction: column;

  justify-content: center;
  align-items: center;

  text-align: center;

  padding: 50px;
}

.successIcon {
  display: flex;

  justify-content: center;
  align-items: center;

  width: 65px;
  height: 65px;

  margin-bottom: 25px;

  border-radius: 50%;

  background: #00aeef;

  color: #ffffff;

  font-size: 32px;
}

.thanksBox h3 {
  margin: 0 0 15px;

  color: #111820;

  font-size: 30px;

  font-weight: 700;
}

.thanksBox p {
  margin: 0;

  color: #68717a;

  font-size: 17px;
}


/* =========================================
   FADE
========================================= */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


/* =========================================
   BOOTSTRAP OVERRIDE
========================================= */

::v-deep .form-control {
  font-size: 16px;
}


/* =========================================
   TABLET
========================================= */

@media only screen and (max-width: 992px) {

  .contactSection {
    padding: 75px 0 85px;
  }

  .contactIntro h2 {
    font-size: 42px;
  }

  .request-a-callback-form {
    padding: 35px;
  }

  .messageField textarea {
    height: 250px;
  }

}


/* =========================================
   MOBILE
========================================= */

@media only screen and (max-width: 768px) {

  .contactSection {
    padding: 60px 0 70px;
  }

  .contactIntro {
    padding: 0 20px;

    margin-bottom: 40px;
  }

  .contactIntro h2 {
    font-size: 35px;
  }

  .contactIntro p {
    font-size: 15px;
  }

  .request-a-callback-form {
    margin: 0 15px;

    padding: 30px 20px;
  }

  .formColumn {
    padding: 0;
  }

  .field {
    margin-bottom: 22px;
  }

  .messageField textarea {
    height: 220px;
  }

  .formFooter {
    flex-direction: column;

    align-items: stretch;

    gap: 20px;
  }

  .submitButton {
    width: 100%;
  }

}


/* =========================================
   SMALL MOBILE
========================================= */

@media only screen and (max-width: 480px) {

  .contactSection {
    padding: 50px 0 60px;
  }

  .contactIntro h2 {
    font-size: 30px;
  }

  .request-a-callback-form {
    margin: 0 10px;

    padding: 25px 18px;
  }

  .field input {
    height: 52px;
  }

  .field textarea {
    min-height: 200px;
  }

  .thanksBox {
    min-height: 300px;

    padding: 30px 15px;
  }

}

</style>